module.exports = __webpack_public_path__ + "assets/img/station1.ce50d7ae.png";